import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { buildFieldName } from '#client/utils/form';

import { FIELD_NAMES } from '../../constants';

const MAX_LENGTH = 10;
const POSTAL_CODE_LABEL = 'Postal code';
const POSTAL_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export default function usePostalCodeField({ namePrefix, validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    required: formatMessage(
      { id: 'shopping.component.addressFieldset.postalCodeField.error.required' },
      { label: POSTAL_CODE_LABEL }
    ),
    maxLength: {
      message: formatMessage(
        { id: 'shopping.component.addressFieldset.postalCodeField.error.maxLength' },
        { label: POSTAL_CODE_LABEL, maxLength: MAX_LENGTH }
      ),
      value: MAX_LENGTH
    },
    pattern: {
      message: formatMessage(
        { id: 'shopping.component.addressFieldset.postalCodeField.error.invalid' },
        { label: POSTAL_CODE_LABEL }
      ),
      value: POSTAL_CODE_REGEX
    }
  };

  const fieldName = buildFieldName(FIELD_NAMES.POSTAL_CODE, namePrefix);

  const {
    field: { onBlur, ...field },
    fieldState: { error }
  } = useController({
    defaultValue: '',
    name: fieldName,
    rules: { ...defaultValidation, ...validation }
  });

  const handleBlur = (e) => {
    field.onChange(e.target.value.trim());
  };

  return {
    error,
    field: {
      ...field,
      value: field.value ?? '',
      onBlur: handleBlur
    }
  };
}
